var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useLogout } from 'shared/hooks';
import { adminSignIn } from 'src/constants/externalRoutes';
import { IDLE_TIMEOUT, PROMPT_TIMEOUT, ACTIVE_EVENTS } from '../constants';
var CrossTab;
(function (CrossTab) {
    CrossTab["close"] = "logout-modal-close";
    CrossTab["Open"] = "logout-modal-open";
})(CrossTab || (CrossTab = {}));
export var useLogoutTimer = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'logout-idle-timer' : _b, _c = _a.timeout, timeout = _c === void 0 ? IDLE_TIMEOUT : _c, _d = _a.promptTimeout, promptTimeout = _d === void 0 ? PROMPT_TIMEOUT : _d, _e = _a.events, events = _e === void 0 ? ACTIVE_EVENTS : _e, _f = _a.eventsThrottle, eventsThrottle = _f === void 0 ? 500 : _f, _g = _a.syncTimers, syncTimers = _g === void 0 ? 500 : _g, _h = _a.crossTab, crossTab = _h === void 0 ? true : _h, props = __rest(_a, ["name", "timeout", "promptTimeout", "events", "eventsThrottle", "syncTimers", "crossTab"]);
    var onClose = props.onClose, onOpen = props.onOpen;
    var logout = useLogout();
    var onMessage = function (data) {
        if (typeof data === 'string') {
            if (data === CrossTab.close && timer.isPrompted()) {
                timer.activate();
            }
            if (data === CrossTab.Open && !timer.isPrompted()) {
                onOpen();
            }
        }
    };
    // Called after IDLE_TIMEOUT ends. Starts PROMPT_TIMEOUT. Also sets to true isPrompted();
    var onPrompt = function () {
        // Open modal
        onOpen();
        setRemaining(promptTimeout);
    };
    // Called after PROMPT_TIMEOUT ends.
    var onIdle = function () {
        // Logout and redirect
        onActive();
        if (timer.isLeader()) {
            logout();
        }
        else {
            window.setLocationHref(adminSignIn);
        }
    };
    var onActive = function () {
        onClose();
        setRemaining(0);
    };
    var signOut = function () {
        onActive();
        logout();
    };
    var timer = useIdleTimer(__assign({ name: name, timeout: timeout, promptTimeout: promptTimeout, events: events, eventsThrottle: eventsThrottle, crossTab: crossTab, onMessage: onMessage, onPrompt: onPrompt, onIdle: onIdle, onActive: onActive, syncTimers: syncTimers, leaderElection: true }, props));
    var _j = useState(0), remaining = _j[0], setRemaining = _j[1];
    var close = function () {
        onActive();
        // notify other tabs that the user closed the modal and reset timer on all
        timer.message(CrossTab.close);
    };
    useEffect(function () {
        var interval = setInterval(function () {
            if (timer.isPrompted()) {
                setRemaining(Math.round(timer.getRemainingTime() / 1000));
            }
        }, 1000);
        return function () {
            clearInterval(interval);
        };
    }, [timer.getRemainingTime, timer.isPrompted]);
    return __assign(__assign({}, timer), { remaining: remaining, close: close, signOut: signOut });
};
